/*
 * layout (root)
 */
import { createRootRoute, Link, Outlet } from "@tanstack/react-router"
import { Container, Header, Page } from "@emr/react-ui"
import i18n from "i18next"
import { useTranslation } from "react-i18next"
import appCss from "../global.css?url"
// import { TanStackRouterDevtools } from "@tanstack/react-router-devtools"
import Layout from "../layout"
import Providers from "../providers"

export const Route = createRootRoute({
	head: () => ({
		meta: [
			{ charSet: "utf-8" },
			{ name: "viewport", content: "width=device-width, initial-scale=1" },
			{ title: i18n.t("head.title") },
		],
		links: [{ rel: "stylesheet", href: appCss }],
	}),
	component: RootLayout,
	notFoundComponent: NotFoundPage,
})

function RootLayout() {
	return (
		<Providers>
			<Layout>
				<Outlet />
				{/* <TanStackRouterDevtools
						initialIsOpen={false}
						position={"bottom-right"}
					/> */}
			</Layout>
		</Providers>
	)
}

function NotFoundPage() {
	const { t } = useTranslation()
	return (
		<Page>
			<Container className={"justify-center"}>
				<Header>{t("common.pageNotFound")}</Header>
				<p>{t("common.pageNotFoundDescription")}</p>
				<span>
					<Link to={"/"}>{t("common.goHome")}</Link>
				</span>
			</Container>
		</Page>
	)
}
